import { connect } from 'react-redux';
import OrderListCustomerPage from './order-list-customer.presentation';
import {
  setOrderListCustomerFilter,
  setOrderListCustomerPaging,
  setOrderListCustomerSort,
} from '../../redux/action';
import * as Constant from '../../constant';

const getFilteredOrderList = (state) => {
  const filteredOrderList = [{
    id: 1,
    soNo: '515321.2IS',
    blNo: 'SITGLCCR150269',
    billTo: 'KRAFT',
  }, {
    id: 2,
    soNo: '515396.2IS',
    blNo: 'ONEYSGNUD7974600',
    billTo: 'KRAFT',
  }];

  const {
    filters, sortField, sortDirection,
  } = state.uiOrderListCustomer;

  return filteredOrderList.sort((left, right) => {
    if (typeof left[sortField] === 'string') {
      if (sortDirection === Constant.TABLE_SORT_ASCENDING) {
        return left[sortField].localeCompare(right[sortField]);
      }
      return right[sortField].localeCompare(left[sortField]);
    }

    if (sortDirection === Constant.TABLE_SORT_ASCENDING) {
      return left[sortField] - right[sortField];
    }
    return right[sortField] - left[sortField];
  })
    .filter(item => item.billTo.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_LIST_BILL_TO].toUpperCase(),
    ) >= 0)
    .filter(item => item.blNo.toUpperCase().indexOf(
      filters[Constant.TABLE_FIELD_ORDER_LIST_BL_NO].toUpperCase(),
    ) >= 0);
};

const getPageFilteredOrderList = (state) => {
  const {
    activePage, pageSize,
  } = state.uiOrderListCustomer;
  const filteredOrderList = getFilteredOrderList(state);

  if (filteredOrderList) {
    const refinedActivePage = activePage || 1;
    const start = Math.min((refinedActivePage - 1) * pageSize,
      filteredOrderList.length);
    const end = Math.min(start + pageSize, filteredOrderList.length);
    return filteredOrderList.slice(start, end);
  }

  return [];
};

const getTotalPage = (state) => {
  const filteredOrderList = getFilteredOrderList(state);
  const { pageSize } = state.uiOrderListCustomer;
  const totalData = filteredOrderList ? filteredOrderList.length : 0;

  return Math.max(Math.ceil(totalData / pageSize), 1);
};

const mapStateToProps = state => ({
  menuOpen: state.uiMenu.menuOpen,
  orders: getPageFilteredOrderList(state),
  filters: state.uiOrderListCustomer.filters,
  activePage: state.uiOrderListCustomer.activePage,
  pageSize: state.uiOrderListCustomer.pageSize,
  totalPage: getTotalPage(state),
  sortField: state.uiOrderListCustomer.sortField,
  sortDirection: state.uiOrderListCustomer.sortDirection,
});

const mapDispatchToProps = dispatch => ({
  onChangeFilter: (filterName, value) => {
    dispatch(setOrderListCustomerFilter(filterName, value));
  },
  onChangePaging: (pageField, value) => {
    dispatch(setOrderListCustomerPaging(pageField, value));
  },
  onChangeSort: (sortField, sortDirection) => {
    dispatch(setOrderListCustomerSort(sortField, sortDirection));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(OrderListCustomerPage);
